import * as React from "react";
import * as ReactDOM from "react-dom";
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { get as getProjection } from "ol/proj";
import { MapContextProvider } from "./Contexts/AppContext";
import { ConexusForm } from "./Providers/mapProvider";
import Favicon from "../src/img/LVM_GEO_logo_128.jpg";

proj4.defs(
    "EPSG:3059",
    "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);
register(proj4);
getProjection("EPSG:3059").setExtent([-1349424.723447654, -595003.4846995564, 2424864.0751299444, 1206812.6189326514]);

// need to import image, or webpack will not copy image file to the dist folder
const favicon = Favicon;

export const renderMap = (): void => {
    const target = document.getElementById("conexus-form");
    const isIFrame = iniFrame();
    const isMobileDevice =
        navigator.maxTouchPoints > 0 || navigator.platform === "iPhone" || navigator.platform === "iPad";
    isMobileDevice && target.classList.add("mobile");
    isIFrame && target.classList.add("iframe");

    ReactDOM.render(
        <MapContextProvider>
            <ConexusForm />
        </MapContextProvider>,
        target
    );
};

const iniFrame = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
